export const buildAclObject = (entityType, entityId, displayName, permission = 'Owner') => ({
  displayName,
  entityId,
  entityType,
  permission,
});
